export const KNOWN_ORIGINS = [
  'https://www.seek.co.nz',
  'https://www.staging.seek.co.nz',
  'https://www.seek.com.au',
  'https://www.staging.seek.com.au',
];

const KNOWN_ORIGIN_SET = new Set<unknown>(KNOWN_ORIGINS);

const isKnownOrigin = (value: unknown) => KNOWN_ORIGIN_SET.has(value);

export const wwwUrl = (
  pathname: string,
  searchParams?: Record<string, string>,
) => {
  const { origin } = window.location;

  const url = new URL(
    isKnownOrigin(origin) ? origin : 'https://www.seek.com.au',
  );

  url.pathname = pathname;

  url.search = new URLSearchParams(searchParams).toString();

  return url.toString();
};
